import { render, staticRenderFns } from "./WidgetImageGalleryRows.vue?vue&type=template&id=2a658136&scoped=true"
import script from "./WidgetImageGalleryRows.vue?vue&type=script&lang=js"
export * from "./WidgetImageGalleryRows.vue?vue&type=script&lang=js"
import style0 from "./WidgetImageGalleryRows.vue?vue&type=style&index=0&id=2a658136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a658136",
  null
  
)

export default component.exports